<template>
  <div>
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="enable_use" slot-scope="props">
        <span v-if="props.item.enable_use">사용함</span>
        <span v-else>사용안함</span>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half" @click.stop.prevent="clickProd(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickProd(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: 'NoPassList',
    mixins: [
      ListMixin
    ],
    data() {
      return {

      }
    },
    created(){
      this.init();
    },
    methods:{
      init() {
        this.initializing('nopass', 'commerce/nopassbook');
      },
      getDataFromServer() {
        this.getData();
      },
      clickProd(item, kind) {
        if(kind === 'update') {
          this.$router.push(this.getPath('commerce/nopass/create?id='+item.id));
        }else if(kind === 'delete') {

          let value = {
            id: item.id,
            url: 'nopass/',
            title: '은행을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
